/* eslint-disable */

(function ($) {
    $.widget('ep.dropdown_record_field', $.ep.base_record_field, {
        options: {
            templateId: 'edit-record-dropdown-template'
        },


        setValues: function () {
            var values = this._model.Values;
            var dropDownOptions = $(".record-dropdown-field option", this.element);

            if (values.length > 0) {
                dropDownOptions.each(function (i) {
                    $(this).prop("selected", $.inArray($(this).attr("valueItem"), values) > -1);
                });
            }

            $('.field-container select', this.element).combobox({width: 460, customScroll: true, adjustDropdownContainer: true, spaceBetween: 6 });
        },

        getData: function () {
            var values = [];

            var selectedValue = $(".record-dropdown-field", this.element).find('option:selected').attr("valueItem");
            if (selectedValue.length > 0) {
                values.push(selectedValue);
            }

            this._model.Values = values;

            return this._model;
        },

        setDisabled: function () {
            $('.field-container select', this.element).prop('disabled', true);
        },

        afterRenderTemplate: function () {
            var _this = this;
            this.setValidationRules();

            $(".record-dropdown-field", this.element).change(function () {
                _this.clearValidationResult();
                this.classList.remove($.validator.defaults.errorClass);

                // update Values
                _this.getData();
                _this.updateBranchVisibility();
            });

            this.element.addClass("dropdownrecordfield");
        },

        setValidationRules: function () {
            if ($.validator.methods.dropDownNotNone == undefined) {
                $.validator.addMethod('dropDownNotNone', function (value, element) {
                    var valueElement = $(element).find('option:selected').attr("valueItem");
                    return (valueElement != '');
                }, this.options.resources.validationRequired);
            }

            $(".record-dropdown-field", this.element).rules("add",
                {
                    dropDownNotNone: this.options.model.Required
                });
        }
    });
})(jQuery);
/* eslint-enable */
